import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HTTP_CONTEXT_ENDPOINT } from '@core/const';
import { OCC_ENDPOINTS, OccProductGroupReferences, ProductGroupReferences } from '@product/const';
import {
  ConverterService,
  OccEndpointsService,
  PRODUCT_REFERENCES_NORMALIZER,
  ProductReference,
} from '@spartacus/core';
import { Observable, map } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class OccProductGroupReferencesService {
  constructor(
    private http: HttpClient,
    private occEndpointsService: OccEndpointsService,
    private converter: ConverterService,
  ) {}

  loadGroups(productCode: string, referenceType: string): Observable<ProductGroupReferences[]> {
    const url = this.occEndpointsService.buildUrl(OCC_ENDPOINTS.groupReferences, {
      urlParams: {
        productCode,
      },
      queryParams: { referenceType, fields: 'groupReferences(code,name)' },
    });

    return this.http
      .get<{ groupReferences: OccProductGroupReferences[] }>(url, {
        context: new HttpContext().set(HTTP_CONTEXT_ENDPOINT, OCC_ENDPOINTS.groupReferences),
      })
      .pipe(map((res) => res.groupReferences));
  }

  loadProducts(
    productCode: string,
    referenceType: string,
    categoryCode: string,
    pageSize?: number,
  ): Observable<ProductReference[]> {
    const url = this.occEndpointsService.buildUrl('productReferences', {
      urlParams: {
        productCode,
      },
      queryParams: { categoryCode, referenceType, pageSize },
    });

    return this.http
      .get<OccProductGroupReferences[]>(url, {
        context: new HttpContext().set(
          HTTP_CONTEXT_ENDPOINT,
          this.occEndpointsService.getRawEndpointValue('productReferences'),
        ),
      })
      .pipe(this.converter.pipeable(PRODUCT_REFERENCES_NORMALIZER));
  }
}
